export default {
  updateAll(state, value) {
    state.all = value
  },
  updateSingle(state, value) {
    state.single = value
  },
  updateProductTitleListImportData(state, value) {
    state.productTitleListImportData = value
  },
  updateProductTitleListManualData(state, value) {
    state.productTitleListManualData = value
  },
  updateProductId(state, value) {
    state.productId = value
  }
}
